import { Text } from 'preact-i18n'
import { Button, Container, Header, Icon, Modal, Segment, Transition } from 'semantic-ui-react'

interface AdaptiveRecognitionGateModalProps {
  open: boolean
  onEnable: () => void
  onCancel: () => void
}

const AdaptiveRecognitionGateModal = ({ open, onEnable, onCancel }: AdaptiveRecognitionGateModalProps) => {
  return (
    <Transition visible={open} animation="scale" duration={300} unmountOnHide>
      <Modal id="are-gate-modal" basic open={true}>
        <Container textAlign="center">
          <Modal.Header>
            <Segment inverted>
              <Header icon>
                <Icon name="info circle" size="huge" />
                <Text id="labelCapture.adaptiveRecognitionGate.title" />
              </Header>
            </Segment>
          </Modal.Header>
          <Modal.Content>
            <Segment inverted>
              <p>
                <Text id="labelCapture.adaptiveRecognitionGate.message" />
              </p>
            </Segment>
          </Modal.Content>
          <Modal.Actions>
            <div style={{ padding: '1rem', display: 'flex', gap: '0.5rem', justifyContent: 'center' }}>
              <Button basic color="grey" inverted onClick={onCancel}>
                <Text id="actions.cancel" />
              </Button>
              <Button color="green" inverted onClick={onEnable}>
                <Icon name="checkmark" />
                <Text id="actions.enable" />
              </Button>
            </div>
          </Modal.Actions>
        </Container>
      </Modal>
    </Transition>
  )
}

export default AdaptiveRecognitionGateModal
